import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as API } from '../axiosConfig';

const SLICE_NAME = 'logExplorer';
const LOG_EXPLORER = `${SLICE_NAME}/search/logs`;

export const searchLogs = createAsyncThunk(LOG_EXPLORER, async (query) => {
  const response = await API.post('/log-explorer/search', query).catch(
    (error) => error && error.response && error.response,
  );
  const data = await { ...response.data };
  return data;
});

const logExplorerSlice = createSlice({
  name: SLICE_NAME,
  initialState: {
    searchResults: [],
  },
  reducers: {},
  extraReducers: {
    [searchLogs.fulfilled]: (state, { payload }) => {
      if (payload.status !== 'OK') {
        state.searchResults = [];
        return;
      }

      if (!payload || !payload.data) {
        return;
      }

      state.searchResults = [...payload.data];
    },
  },
});

export const logExplorerActions = logExplorerSlice.actions;

export default logExplorerSlice.reducer;
